import React, { useState, useEffect } from 'react';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import AddSupplierModal from "../Master/Add/AddSupplierModal";
import axios from 'axios';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import PurchaseSupplierList from '../CommonComp/PurchaseSupplierList';
import BankSuggestionBox from '../CommonComp/BankSuggestionBox';
import ViewSupplier from '../Master/ViewSupplier';
import generatePDFNew from '../Purchase/PurchaseHistoryInvoice';
import { Link, useParams, useNavigate } from 'react-router-dom';
import CustomDateInput from '../CommonComp/CustomDateInput';
import Swal from 'sweetalert2';

const PayBills = () => {
    const [suppliers, setSuppliers] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState('');
    const accessToken = localStorage.getItem('accessToken');
    const user_id = localStorage.getItem('user_id');


    //const [bills, setBills] = useState([]);
    const [supplierInfo, setSupplierInfo] = useState(null);
    const [bills, setBills] = useState(0);
    const [payingAmount, setPayingAmount] = useState(0);
    const [bankInfo, setBankInfo] = useState(null);
    const [tableRow, setTableRow] = useState([]);
    const [checkedRows, setCheckedRows] = useState([]);
    const [deliveryDate, setDeliveryDate] = useState('');
    const [details, setDetails] = useState('');
    const [transactionRef, setTransactionRef] = useState('');

    const navigateToPurchaseList = useNavigate();

    const parseMoney = (v) => {
        if (v === null || v === undefined || v === '') return NaN;
        return parseFloat(String(v).replace(/,/g, '').trim());
    };

    const roundMoney = (n) => {
        const v = parseMoney(n);
        if (Number.isNaN(v)) return NaN;
        return Math.round(v * 100) / 100;
    };

    const formatMoneyStr = (n) => {
        if (n === null || n === undefined || n === '') return '';
        let v = typeof n === 'number' ? n : parseMoney(n);
        if (Number.isNaN(v)) {
            v = Number(String(n).replace(/,/g, '').trim());
        }
        if (!Number.isFinite(v)) return '';
        const cents = Math.round(v * 100);
        return (cents / 100).toFixed(2);
    };

    const rowInPaymentScope = (idx, rows, selectedRows) =>
        selectedRows.includes(idx) || (parseFloat(rows[idx]?.pay) || 0) > 0;

    const computePaymentSummary = (rows, selectedRows) => {
        const byPurchase = {};
        rows.forEach((row, idx) => {
            if (!rowInPaymentScope(idx, rows, selectedRows)) return;
            const pid = row.purchase_id || `_row_${idx}`;
            if (!byPurchase[pid]) {
                byPurchase[pid] = { invBalance: 0, creditPay: 0, cashPay: 0 };
            }
            const pay = parseFloat(row.pay) || 0;
            if (isCreditRow(row)) {
                byPurchase[pid].creditPay += pay;
            } else if (String(row.type || '').toUpperCase() === 'INV') {
                const b = roundMoney(row.balance);
                byPurchase[pid].invBalance += Number.isNaN(b) ? 0 : b;
                byPurchase[pid].cashPay += pay;
            }
        });
        let payingTotal = 0;
        let remainingTotal = 0;
        let invBillTotal = 0;
        Object.values(byPurchase).forEach((g) => {
            payingTotal += g.creditPay + g.cashPay;
            invBillTotal += g.invBalance;
            remainingTotal += Math.max(0, Math.round((g.invBalance - g.creditPay - g.cashPay) * 100) / 100);
        });
        return {
            payingAmount: Math.round(payingTotal * 100) / 100,
            remaining: Math.round(remainingTotal * 100) / 100,
            totalInvBill: Math.round(invBillTotal * 100) / 100,
        };
    };

    const summaryBalanceDiff = () => computePaymentSummary(tableRow, checkedRows).remaining;

    const formatLedgerBalance = (bill, rows, selectedRows) => {
        const bal = roundMoney(bill.balance);
        if (Number.isNaN(bal)) return '';
        const base = Math.max(0, bal);
        const pay = parseFloat(bill.pay) || 0;
        if (isCreditRow(bill)) {
            return Math.max(0, Math.round((base - pay) * 100) / 100).toFixed(2);
        }
        if (String(bill.type || '').toUpperCase() === 'INV') {
            const credits = getCreditsByPurchase(rows, selectedRows);
            const credit = credits[bill.purchase_id] || 0;
            return Math.max(0, Math.round((base - credit - pay) * 100) / 100).toFixed(2);
        }
        return base.toFixed(2);
    };

    const isPayInputDisabled = (bill) => {
        const b = roundMoney(bill.balance);
        return Number.isNaN(b) || b <= 0;
    };

    const getMaxPayForRow = (row) => {
        const b = parseMoney(row.balance);
        if (!Number.isNaN(b)) return Math.max(0, b);
        return 0;
    };

    const isCreditRow = (row) => String(row.type || '').toLowerCase() === 'credit';

    const getCreditsByPurchase = (rows, selectedRows) => {
        const map = {};
        rows.forEach((row, idx) => {
            if (!rowInPaymentScope(idx, rows, selectedRows) || !isCreditRow(row)) return;
            const pid = row.purchase_id;
            if (!pid) return;
            map[pid] = (map[pid] || 0) + (parseFloat(row.pay) || 0);
        });
        return map;
    };

    const handleDateChange = (e) => {
        setDeliveryDate(e.target.value);
    };
    const handleDetailsChange = (e) => {
        setDetails(e.target.value);
    };

    const handleTransactionChange = (e) => {
        setTransactionRef(e.target.value);
    };

    const handleBankChange = (selectedBank) => {
        setBankInfo(selectedBank);
    };

    const handleSupplierChange = (selectedSupplier) => {
        setSupplierInfo(selectedSupplier);
        if (selectedSupplier) {
            getRequiresSupplierList(selectedSupplier.value);
        } else {
            setTableRow([]);
        }
    };

    const getRequiresSupplierList = (supplierId) => {
        if (supplierId) {
            axios.get(`${config.api_url}/ws-supplier-bills/${supplierId}`)
                .then(response => {

                    if (Array.isArray(response.data)) {


                        setTableRow(response.data);
                    } else {
                        console.error('Unexpected data format for bills:', response.data);

                        setTableRow([]);
                    }
                })
                .catch(error => {
                    console.error('Error fetching bills:', error);
                    setTableRow([]);
                });
        } else {
            setTableRow([]);
        }
    };


    const getEffectiveMaxPay = (row, rows, selectedRows) => {
        const base = getMaxPayForRow(row);
        if (row.type === 'INV') {
            const credits = getCreditsByPurchase(rows, selectedRows);
            const credit = credits[row.purchase_id] || 0;
            return Math.max(0, Math.round((base - credit) * 100) / 100);
        }
        return base;
    };

    const handlePayChange = (index, value) => {
        const newTableRow = [...tableRow];
        const row = { ...newTableRow[index] };
        const maxPay = getEffectiveMaxPay(row, tableRow, checkedRows);
        if (value === '' || value === null) {
            row.pay = '';
        } else {
            const num = parseFloat(value);
            if (Number.isNaN(num)) {
                row.pay = '';
            } else if (num < 0) {
                row.pay = 0;
            } else if (num > maxPay + 1e-9) {
                Swal.fire({
                    title: 'Error!',
                    text: 'Pay amount cannot exceed the remaining balance.',
                    icon: 'error',
                    timer: 2000,
                    showConfirmButton: false,
                });
                row.pay = maxPay;
            } else {
                row.pay = num;
            }
        }
        newTableRow[index] = row;
        setTableRow(newTableRow);
        calculateTotals(newTableRow);
    };

    const handleCheckboxChange = (index) => {
        setCheckedRows((prevCheckedRows) => {
            const isChecking = !prevCheckedRows.includes(index);
            const newCheckedRows = isChecking
                ? [...prevCheckedRows, index]
                : prevCheckedRows.filter((rowIndex) => rowIndex !== index);

            if (isChecking) {
                const row = tableRow[index];
                if (row && isCreditRow(row)) {
                    const maxPay = getMaxPayForRow(row);
                    const newTableRow = [...tableRow];
                    newTableRow[index] = { ...row, pay: maxPay };
                    setTableRow(newTableRow);
                    calculateTotals(newTableRow, newCheckedRows);
                    return newCheckedRows;
                }
            }

            calculateTotals(tableRow, newCheckedRows);
            return newCheckedRows;
        });
    };

    const calculateTotals = (rows, selectedRows = checkedRows) => {
        const summary = computePaymentSummary(rows, selectedRows);
        setPayingAmount(summary.payingAmount);
        setBills(summary.totalInvBill);
    };




    const fetchData = async () => { };


    const handleSubmit = async (event, action) => {
        event.preventDefault();

        const creditsByPurchase = getCreditsByPurchase(tableRow, checkedRows);
        const overPay = tableRow
            .filter((_, idx) => checkedRows.includes(idx))
            .find((row) => {
                const pay = parseFloat(row.pay) || 0;
                if (isCreditRow(row)) {
                    return pay > getMaxPayForRow(row) + 1e-9;
                }
                if (row.type === 'INV') {
                    const creditApply = creditsByPurchase[row.purchase_id] || 0;
                    return pay + creditApply > getMaxPayForRow(row) + 1e-9;
                }
                return pay > getMaxPayForRow(row) + 1e-9;
            });
        if (overPay) {
            Swal.fire({
                title: 'Error!',
                text: 'Pay amount cannot exceed the remaining balance for a selected bill.',
                icon: 'error',
                timer: 2000,
                showConfirmButton: false,
            });
            return;
        }

        const formData = new FormData();
        const supplier = supplierInfo ? supplierInfo.value : '';
        const dDate = deliveryDate ? deliveryDate : '';
        const bank = bankInfo ? bankInfo.value : '';
        const detailInfo = details ? details : '';
        const transactionInfo = transactionRef ? transactionRef : '';

        formData.append('supplier_id', supplier);
        formData.append('date', dDate);
        formData.append('bank_id', bank);
        formData.append('details', detailInfo);
        formData.append('transaction_ref', transactionInfo);
        formData.append('paying_amount', Math.round(payingAmount * 100) / 100);
        formData.append('balance', computePaymentSummary(tableRow, checkedRows).remaining);

        // Gather data for the checked rows
        const selectedRowsData = tableRow
            .filter((_, idx) => checkedRows.includes(idx))
            .filter((row) => (parseFloat(row.pay) || 0) > 0)
            .map((row) => ({
                purchase_id: row.purchase_id,
                pay: parseFloat(row.pay) || 0,
                purchase_ledger_id: row.id,
                ledger_type: row.type || '',
                bill_no: row.bill_no || '',
                job_ref: row.job_ref || ''
            }));

        if (selectedRowsData.length === 0) {
            Swal.fire({
                title: 'Error!',
                text: 'Select at least one bill and enter a pay amount.',
                icon: 'error',
                timer: 2500,
                showConfirmButton: false,
            });
            return;
        }

        formData.append('selected_rows', JSON.stringify(selectedRowsData));

        formData.append('user_id', user_id);

        // Send the form data to the backend
        const apiUrl = `${config.api_url}/ws-submit-purchase-payment`;

        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    authorization: `Bearer ${accessToken}`,
                },
                body: formData,
            });

            const data = await response.json();

            if (!response.ok || !data.success) {
                Swal.fire({
                    title: 'Error!',
                    text: data.message || 'Failed to submit payment data',
                    icon: 'error',
                    timer: 3000,
                    showConfirmButton: false,
                });
                return;
            }

            if (action === 'close') {
                navigateToPurchaseList('/PurchaseLedger');
            } else if (action === 'new') {



            }

            // Reset the form if submission is successful (optional)
            /*setCheckedRows([]);
            setPayingAmount(0);
            setBills(0);
            setTableRow([]);*/
        } catch (error) {
            console.error('Error submitting payment data:', error);
        }
    };

    return (
        <div>
            <Header />
            <ViewSupplier accessToken={accessToken} />

            <AddSupplierModal fetchData={fetchData} />
            <div className="breadcrumbs">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-lg-12 col-sm-12">
                            <a href="#"><i className="fa fa-home"></i></a> &gt;
                            <a href="/Dashboard">Dashboard</a> &gt;
                            <span className="last-crumb">Pay Bills (Supplier Payment)</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="main-container">
                <form id='new_sales_order'>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 col-lg-12 col-sm-12">
                                <div className="show-order-area dashboard">
                                    <div style={{ marginBottom: '20px', float: 'left' }}>
                                        <div className="newsalesorderform">
                                            <div style={{ float: "right", width: "100%" }}>
                                                <a href="#" className="create-catalogue-btn" data-bs-toggle="modal"
                                                    data-bs-target="#add-supplier" ><i className='fa fa-plus'></i>&nbsp;New Supplier</a>
                                            </div>
                                            <hr />
                                            <div className="row mb-3 padd-l-13px">
                                                <div className="col-6 col-lg-6 col-sm-6">
                                                    <div className="row mb-3">
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="supplier" className="col-form-label">Select Supplier <span className='red'>*</span> </label>
                                                        </div>
                                                        <div className="col-8 col-lg-9 col-sm-9">



                                                            <PurchaseSupplierList onSupplierChange={handleSupplierChange} />


                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="delivery_date" className="col-form-label">Date </label>
                                                        </div>
                                                        <div className="col-8 col-lg-3 col-sm-3">
                                                            <CustomDateInput
                                                                name="delivery_date"
                                                                id="delivery_date"
                                                                value={deliveryDate}
                                                                onChange={handleDateChange}
                                                            />
                                                        </div>
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="bank" className="col-form-label">Bank </label>
                                                        </div>
                                                        <div className="col-8 col-lg-3 col-sm-3">
                                                            <BankSuggestionBox onBankChange={handleBankChange} />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="details" className="col-form-label">Details </label>
                                                        </div>
                                                        <div className="col-8 col-lg-9 col-sm-9">
                                                            <input type="text" className="form-control" name="details" onChange={handleDetailsChange} value={details} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-6 col-lg-6 col-sm-6">
                                                    <div className="row mb-3">
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="transaction_ref" className="col-form-label">Transaction Ref </label>
                                                        </div>
                                                        <div className="col-8 col-lg-9 col-sm-9">
                                                            <input type="text" className="form-control" name="transaction_ref" onChange={handleTransactionChange} value={transactionRef} />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="paying_amount" className="col-form-label">Paying Amount</label>
                                                        </div>
                                                        <div className="col-8 col-lg-9 col-sm-9">
                                                            <input type="text" className="form-control" disabled value={formatMoneyStr(payingAmount)} name="paying_amount" />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="balance" className="col-form-label">Balance</label>
                                                        </div>
                                                        <div className="col-8 col-lg-9 col-sm-9">
                                                            <input type="text" className="form-control" disabled value={formatMoneyStr(summaryBalanceDiff())} name="balance" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="verical-scrl-wrapper common-table paybill-table" id="style-3">
                                                <table className="table table-bordered dataTable" id="dsTable">
                                                    <thead>
                                                        <tr>
                                                            <th>Select</th>
                                                            <th>ID</th>
                                                            <th>Raised On</th>
                                                            <th>Type</th>
                                                            <th>Bill No</th>
                                                            <th>Job Ref</th>
                                                            <th>P.O ID</th>
                                                            <th>Supplier (ID)</th>
                                                            <th>Value</th>
                                                            <th>Balance</th>
                                                            <th>Pay</th>
                                                            <th>Due Date</th>
                                                            <th>Created By</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {tableRow.map((bill, index) => (
                                                            <tr key={bill.id}>
                                                                <td>


                                                                    <label className="checkbox">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={checkedRows.includes(index)}
                                                                            onChange={() => handleCheckboxChange(index)}
                                                                        />
                                                                        <span className="default"></span>
                                                                    </label>

                                                                </td>
                                                                <td><a href='#'>{bill.id}</a></td>
                                                                <td>{bill.created_date}</td>
                                                                <td>{bill.type}</td>
                                                                <td>{bill.bill_no}</td>
                                                                <td>{bill.job_ref}</td>
                                                                <td>
                                                                    <a
                                                                        href="#"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            if (bill.grn_id) {
                                                                                generatePDFNew(bill.grn_id, true);
                                                                            }
                                                                        }}
                                                                    >
                                                                        {bill.reference_no}
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="#"
                                                                        className="view-supplier"
                                                                        data-id={bill.supplier_id}
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#viewsupplier"
                                                                    >
                                                                        {bill.name}
                                                                    </a>
                                                                </td>
                                                                <td className="paybill-cell-money">{formatMoneyStr(bill.value)}</td>
                                                                <td className="paybill-cell-money">{formatLedgerBalance(bill, tableRow, checkedRows)}</td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        name="pay[]"
                                                                        className="form-control qtyinputbox"
                                                                        value={bill.pay|| ''}
                                                                        style={{ textAlign: 'right' }}
                                                                        onChange={(e) => handlePayChange(index, e.target.value)}
                                                                        disabled={isPayInputDisabled(bill)}
                                                                        placeholder="Enter Amount"
                                                                        inputMode="decimal"
                                                                    />
                                                                </td>
                                                                <td>{bill.due_date}</td>
                                                                <td>{bill.createdBy}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <hr />
                                            <a href="#" className="common-closebtn">Cancel</a> &nbsp;
                                            <div className="btn-group bouble-btn" role="group" aria-label="Basic example">
                                                <button type="button" onClick={(e) => handleSubmit(e, 'close')} className="saveclose">Save & Close</button>
                                                <button type="button" onClick={(e) => handleSubmit(e, 'new')} className="savenew">Save & New</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <Footer />
        </div>
    );
};

export default PayBills;
